// VisionContext.js
import React, { createContext, useContext, useState } from "react";

const VisionContext = createContext();

export const VisionContextProvider = ({ children }) => {
  const [visionData, setVisionData] = useState({
    actionTypeIds: [],
    alertTypeIds: [],
  });
  const [showCheckInCheckOut, setShowCheckInCheckOut] = useState(false);
  const [videoWall, setVideoWall] = useState([]);

  const updateState = (key, value) => {
    setVisionData((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <VisionContext.Provider
      value={{
        visionData,
        setVisionData,
        updateState,
        showCheckInCheckOut,
        setShowCheckInCheckOut,
        setVideoWall,
        videoWall,
      }}
    >
      {children}
    </VisionContext.Provider>
  );
};

// ✅ Fix here too: use VisionContext not VisionContextProvider
export const useVisionContext = () => useContext(VisionContext);
